import React from 'react'
import { ProductBoxWrapper, ProductExtra, ProductInfo, Summary, Wrapper } from './styled'
import { ReactComponent as CloseSvg } from 'lib/core/resources/svg/close.svg'
import { ReactComponent as CheckSvg } from 'resources/svg/icons/check.svg'
import { ReactComponent as NegativeSvg } from 'resources/svg/icons/close.svg'
import { Link, useHistory } from 'react-router-dom'
import { Button } from 'lib/ui/components'
import { useTrustpilotReviews } from 'hooks/trustpilot'
import { RatingStars } from 'components/Reviews/components/RatingStars'
import { useComparisonContext, useProductBySku, ProductPrice } from 'lib/modules/catalog'

interface Props {
  index: number
  sku: string
}

export const ProductToCompare: React.FC<Props> = ({ index, sku }) => {
  const { removeProduct } = useComparisonContext()
  const history = useHistory()
  const { product } = useProductBySku({ sku })

  const { reviewsOverview } = useTrustpilotReviews(false, sku)
  const ratingPercentage = reviewsOverview?.starsAverage
  const reviewsCount = reviewsOverview?.numberOfReviews?.total

  if (!product) {
    return null
  }

  const {
    image,
    name,
    price,
    urlKey,
    customAttribute,
    customAttributeList
  } = product

  const imageUrl = image?.default.url

  const removeProductToCompare = () => {
    removeProduct(index)
    history.push('/product-comparison')
  }

  const redirectToProduct = () => {
    history.push(urlKey ?? '')
  }

  const [discreet] = customAttribute?.discreet ?? []
  const [overnight] = customAttribute?.overnight ?? []
  const [innerLegCuff] = customAttribute?.innerLegCuff ?? []

  const includedAttributes = ['discreet', 'hip_waist_max', 'hip_waist_min', 'individually_wrapped', 'inner_leg_cuff', 'overnight', 'patterned_design', 'reusable', 'wings']
  const productSpecs = customAttributeList?.filter((attribute: any) => {
    return includedAttributes.includes(attribute.code)
  })

  const featuredText = () => {
    if (overnight) {
      return 'Great for a good night\'s sleep'
    } else if (discreet) {
      return 'Great for a discreet look'
    } else if (innerLegCuff) {
      return 'Great for protection against leaks'
    }
  }
  return (
    <Wrapper>
      <ProductBoxWrapper>
        <div className='remove' onClick={removeProductToCompare}>
          <CloseSvg />
        </div>
        <div className='image'>
          <img src={imageUrl} alt={name} />
        </div>
        <ProductInfo>
          <h2>{name}</h2>
          <Button onClick={redirectToProduct}>
            View Product
          </Button>
        </ProductInfo>
      </ProductBoxWrapper>
      <ProductExtra>
        <div>
          <ProductPrice price={price} />
          <p>With subscription</p>
        </div>
        <div className='row reviews'>
          <Summary>
            <div className='rating__average'>
              <RatingStars
                ratingPercentage={ratingPercentage}
                reviewsCount={reviewsCount}
              />
            </div>
            <Link to={{
              pathname: `/${urlKey}`,
              hash: '#reviews',
              state: { openReviews: true }
            }}
            >
              {reviewsCount === 1 ? 'Review' : 'Reviews'}
            </Link>
          </Summary>
        </div>
        <div className='row specs'>
          <ul>
            {productSpecs?.map((spec, i) => {
              const [value] = spec.value
              const getSpecValue = () => {
                switch (value) {
                  case '':
                    return <span className='icon icon--negative'><NegativeSvg /></span>
                  case '1':
                    return <span className='icon icon--positive'><CheckSvg /></span>
                  default:
                    return <span>{value}</span>
                }
              }
              return (
                <li key={i}>
                  <span>
                    {spec.label}
                  </span>
                  {getSpecValue()}
                </li>
              )
            })}
          </ul>
        </div>
        <div className='row featured'>
          <p><strong>{featuredText}</strong></p>
        </div>
        <div className='row'>
          <Button onClick={redirectToProduct}>View Product</Button>
        </div>
      </ProductExtra>
    </Wrapper>
  )
}
